export const defaultChartColors = [
    '#EDDA26',
    '#F401F9',
    '#A5D673',
    '#9747FF',
    '#FF9900',
    '#AD3D4B',
    '#009BDF'
];